<template>
  <!-- 保单号 -->
  <div class="detailsNumber">
    <!-- 头部 -->
    <div class="numberTh">
      <span class="baodanId">订单编号: {{ rowOrder.orderSn }}</span>

      <!-- 未支付操作按钮 -->
      <div class="NoPay" v-if="rowOrder.orderStatus == 10">
        <el-button
          class="button14"
          type="primary"
          @click="PayMoney()"
          v-if="rowOrder.payType == 1"
          >立即支付
        </el-button>
        <el-button
          class="button14"
          style="width: 118px"
          type="primary"
          @click="printPay()"
          v-if="rowOrder.payType == 0"
          >打印付款通知书</el-button
        >
        <el-button
          size="small"
          @click="getPayInfo"
          class="defaultColor button14"
          >投保人信息</el-button
        >
        <el-button
          id="resetButton"
          size="small"
          @click="cancelOrder()"
          class="defaultColor button14 wuwuwu"
          :loading="disBtn"
          :disabled="disBtn"
          >取消订单</el-button
        >
      </div>

      <!-- 已支付操作按钮 -->
      <div class="YesPay" v-else>
        <el-button @click="getPayInfo" class="defaultColor button14"
          >投保人信息</el-button
        >
      </div>
    </div>
    <!-- 分割线 -->
    <el-divider></el-divider>

    <!--订单 信息 -->
    <table class="tableALL">
      <tr class="rowCLasspad">
        <td>
          <span> 订单状态:</span>
          <span class="font600" :class="orderClolor[rowOrder.orderStatus]">
            {{ setOrderS[rowOrder.orderStatus] }}</span
          >
        </td>
        <td class="paddingLeft">
          <span>险种:</span>
          <span class="font400"> {{ rowOrder.insureName }}</span>
        </td>
        <td>
          <span> 承保机构:</span>
          <span class="font400"> {{ rowOrder.insureCompanyName }}</span>
        </td>
      </tr>
      <tr class="rowCLasspad">
        <td>
          <span> 更新时间:</span>
          <span class="font400">
            {{ rowOrder.updateTime | formatDate("yyyy-MM-dd hh:mm") }}</span
          >
        </td>
        <td class="flex2Dis paddingLeft">
          <span> 支付方式:</span>
          <span class="font400"> {{ setPayS(rowOrder.payType) }}</span>
        </td>
      </tr>
      <tr class="rowCLasspad">
        <td>
          <span>订单金额:</span>
          <span class="font400"> {{ rowOrder.sumPremium }} 元</span>
        </td>
        <td class="flex2Dis paddingLeft">
          <span> 自缴保费:</span>
          <span class="font400"> {{ rowOrder.selfPremium }} 元</span>
        </td>
      </tr>
    </table>
    <!-- 分割线 -->
    <el-divider></el-divider>
  </div>
</template>

<script>
import {
  delOrdercancel,
  getPayUrl,
  getofflinePayment,
} from "@/api/request/snkd.produce";
import { order_state, pay_state } from "@/confing/map_tab.js";

export default {
  name: "OrderCar",
  props: {
    rowOrder: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      setOrderS: order_state,
      disBtn: false,
      orderClolor: {
        10: "noPaid",
        20: "havePaid",
        30: "closePaid",
        40: "havePaid",
      },
    };
  },
  computed: {},
  methods: {
    setPayS(type) {
      return pay_state[type];
    },
    // 取消订单
    cancelOrder() {
      this.$confirm("确定取消保险订单?", "提示", {
        showClose: true,
        type: "warning",
        customClass: "message-box-height",
      })
        .then(async () => {
          // 取消订单--  发送请求--修改状态-- 重新获取订单详情
          this.disBtn = true;
          const res = await delOrdercancel({ id: this.rowOrder.id });
          if (res.respCode === 0) {
            // 触发父组件重新获取订单详情
            this.$message({
              type: "success",
              message: "取消成功!",
            });
            this.disBtn = false;
            this.$emit("alginGet");
          } else {
            this.disBtn = false;
          }
        })
        .finally(() => {
          // 解决element 按钮选中状态
          this.$nextTick(() => {
            document.querySelector("#resetButton").blur();
          });
        });
    },

    // 获取支付链接
    async PayMoney() {
      const { respCode, obj } = await getPayUrl({
        id: this.rowOrder.id,
      });
      if (respCode === 0) {
        window.open(obj.payUrl);
        this.$confirm("是否完成付款？已完成付款请刷新页面", "提示", {
          confirmButtonText: "刷新",
          cancelButtonText: "取消",
          type: "warning",
          customClass: "message-box-height",
        }).then(() => {
          this.$emit("alginGet");
          this.$message({
            type: "success",
            message: "刷新成功!",
          });
        });
      }
    },

    // 获取付款通知书 打印 链接
    async printPay() {
      // console.log("打印付款通知书--- 获取到打印的文件");
      const { respCode, obj } = await getofflinePayment({
        id: this.rowOrder.id,
      });
      if (respCode === 0) {
        window.open(obj);
      }
    },

    // 告诉父组件的打开投保人信息弹出框
    getPayInfo() {
      this.$emit("openUser");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-divider--horizontal {
  background-color: #e5e5e5 !important;
}
.detailsNumber {
  width: 1140px;
  height: 280px;
  margin: 0 auto;
}
.numberTh {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-divider--horizontal {
  background-color: #f5ebdf;
  margin: 20px 0;
}
.baodanId {
  font-size: 20px;
  color: $--color-primary;
}

.font600 {
  font-size: 20px;
  font-weight: 600;
  margin-left: 10px;
}

.font400 {
  font-size: 16px;
  font-weight: 400;
  margin-left: 10px;
  color: #303133;
}
.el-button {
  width: 92px;
  height: 40px;
  padding: 0;
}
.tableALL {
  width: 100%;
  // background-color: yellow;
}
.rowCLasspad {
  line-height: 50px;
  color: #303133;
  display: flex;
  td {
    flex: 1;
  }
}
.flex2Dis {
  flex: 2 !important;
}
.paddingLeft {
  padding-left: 20px;
}
</style>
